;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { buildQueryParams } from '@workspace/ui/lib';
import type { ApiResponse } from '@workspace/ui/types';
import fetchAPI from '@/lib/fetch-api';
import type { PersonResponse, TransferRecipient } from '@/types/people';

export async function getPeople(filters: {
  current_page: number;
  per_page: number;
  search?: string;
  organisation_id?: number;
  statuses?: string[];
  roles?: string[];
  unique_users?: boolean;
  user_ids?: string[];
}): Promise<ApiResponse<PersonResponse[]>> {
  if (!filters.organisation_id || filters.organisation_id <= 0) {
    throw new Error('Invalid organization ID provided.');
  }

  if (filters.current_page < 1 || filters.per_page <= 0) {
    throw new Error('Invalid pagination parameters.');
  }

  const queryParams = buildQueryParams({
    ...filters,
  });

  const apiUrl = process.env.NEXT_PUBLIC_EOR_API_URL;

  if (!apiUrl) {
    throw new Error('[getPeople] NEXT_PUBLIC_EOR_API_URL is not set');
  }

  const response = await fetchAPI<PersonResponse[]>(`${apiUrl}/people?${queryParams.toString()}`, {
    method: 'GET',
  });

  if (!response.success) {
    throw new Error(response.error || response.message || 'Failed to fetch people');
  }

  return {
    ...response,
    message: response.message || 'People fetched successfully',
  };
}

export async function getTransferRecipients(filters: {
  current_page: number;
  per_page: number;
  search?: string;
}): Promise<ApiResponse<TransferRecipient[]>> {
  if (filters.current_page < 1 || filters.per_page <= 0) {
    throw new Error('Invalid pagination parameters.');
  }

  const queryParams = buildQueryParams({
    ...filters,
  });

  const apiUrl = process.env.NEXT_PUBLIC_EOR_API_URL;

  if (!apiUrl) {
    throw new Error('[getTransferRecipients] NEXT_PUBLIC_EOR_API_URL is not set');
  }

  const response = await fetchAPI<TransferRecipient[]>(
    `${apiUrl}/organisations/transfer-recipients?${queryParams.toString()}`,
    {
      method: 'GET',
    }
  );

  if (!response.success) {
    throw new Error(response.error || response.message || 'Failed to fetch transfer recipients');
  }

  return {
    ...response,
    message: response.message || 'Transfer recipients fetched successfully',
  };
}
